import React from 'react';

import { TABLE_CELL_FONT_SIZE } from './constants';
import Layout from '../Layout';
import Text from '../Text';

interface Props {
  value?: number | null;
}

const NumberCell: React.FC<Props> = ({ value }) => {
  return (
    <Layout flexGrow={1} paddingRight={16}>
      <Text size={TABLE_CELL_FONT_SIZE} align="right">
        {value}
      </Text>
    </Layout>
  );
};

export default NumberCell;
